import MuiButton from '@material-ui/core/Button';
import styled from 'styled-components';

const Button = styled(MuiButton)<{
  padding?: string;
  $lowerCase?: boolean;
  $isIcon?: boolean;
  $isAlert?: boolean;
  $isSmall?: boolean;
  $isBackgroundless?: boolean;
  $customColor?: string;
}>`
  && {
    background: ${({ $isAlert, $isBackgroundless, $customColor }) =>
      $isAlert
        ? (props) => props.theme.colors.radicalRed
        : $customColor
        ? $customColor
        : $isBackgroundless
        ? 'none'
        : '#5cabdd'};
    border-radius: 8px;
    font-weight: 600;
    font-size: ${({ $isSmall }) => ($isSmall ? '8px' : '12px')};
    line-height: ${({ $isSmall }) => ($isSmall ? '4px' : '18px')};
    color: ${({ $customColor }) =>
      $customColor ? $customColor : (props) => props.theme.colors.white} !important;
    flex-shrink: 0;
    padding: ${({ padding, $isIcon, $isSmall }) => {
      return padding ? padding : $isIcon ? '0' : $isSmall ? '10px 2px' : '11px 26px';
    }};
    min-width: ${({ $isIcon }) => ($isIcon ? '40px' : 'initial')};
    width: ${({ $isIcon, $isSmall }) => ($isSmall ? '80px' : $isIcon ? '40px' : 'initial')};
    height: ${({ $isIcon, $isSmall }) => ($isSmall ? '20px' : $isIcon ? '40px' : 'initial')};
    text-transform: ${({ $lowerCase }) => {
      return $lowerCase ? 'initial' : 'uppercase';
    }};
    :disabled {
      opacity: 1;
      background-color: ${(props) => props.theme.colors.grey};
    }
    &:hover {
      color: #ffffff;
      background: ${({ $isAlert, $customColor, $isBackgroundless }) =>
        $isAlert
          ? (props) => props.theme.colors.radicalRed
          : $customColor
          ? $customColor
          : $isBackgroundless
          ? 'none'
          : '#5cabdd'};
    }
  }
`;

export default Button;
